import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
// import {
// 	Calendar,
// 	DateInput
// } from '@progress/kendo-dateinputs-vue-wrapper'
import { Button, ButtonGroup, ButtonGroupButton, ToolBar, ToolBarItem, ButtonsInstaller } from "@progress/kendo-buttons-vue-wrapper";
import { Grid, GridColumnMenuSort, GridColumnMenuFilter, GridNoRecords } from "@progress/kendo-vue-grid";
// import Menu from './vue-burger-menu/components/Menu'
import Push from "./vue-burger-menu/components/Menu/push.vue";
import Slide from "./vue-burger-menu/components/Menu/slide.vue";
import { ChartInstaller } from "@progress/kendo-charts-vue-wrapper";
import PageHeader from "../components/layout/pageHeader.vue";
import GridToolbar from "../components/toolbar/gridToolbar.vue";
import cellDeleteCommand from "../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../components/grid/cellTemplate/cellTemplate.vue";
import { Notification, Tooltip, KendoPopupsInstaller } from "@progress/kendo-popups-vue-wrapper";
import { MaskedTextBox, NumericTextBox, ColorPicker, Slider, RangeSlider, Switch, InputsInstaller } from "@progress/kendo-inputs-vue-wrapper";
import headerTemplateVue from "../components/grid/headerTemplate/headerTemplate.vue";
import { IntlProvider, load, LocalizationProvider, loadMessages } from "@progress/kendo-vue-intl";
import { DateinputsInstaller } from "@progress/kendo-dateinputs-vue-wrapper";
import { LayoutInstaller } from "@progress/kendo-layout-vue-wrapper";
import { DropdownsInstaller } from "@progress/kendo-dropdowns-vue-wrapper";
import NoSidebar from "../components/layout/noSidebarLayout.vue";
import Default from "../components/layout/defaultLayout.vue";
import ReportFilters from "../components/report-filters/report-filter.vue";
import { TabStrip } from "@progress/kendo-layout-vue-wrapper";
import PortalVue from "portal-vue";
import { DialogInstaller } from "@progress/kendo-dialog-vue-wrapper";
import PrettyCheckbox from 'pretty-checkbox-vue';

const GlobalComponents = {
	install(Vue) {
		Vue.component("kendo-button", Button);
		Vue.component("kendo-switch", Switch);
		Vue.component("kendo-notification", Notification);
		Vue.component("kendo-tooltip", Tooltip);
		Vue.component("kendo-maskedtextbox", MaskedTextBox);
		Vue.component("kendo-numerictextbox", NumericTextBox);
		Vue.component("kendo-colorpicker", ColorPicker);
		Vue.component("Grid", Grid);
		Vue.component("GridColumnMenuSort", GridColumnMenuSort);
		Vue.component("GridColumnMenuFilter", GridColumnMenuFilter);
		Vue.component("grid-norecords", GridNoRecords);
		Vue.component('intl-provider', IntlProvider);
		//Vue.component(load.name, load);
		Vue.component('localization-provider', LocalizationProvider);
		//Vue.component(loadMessages.name, loadMessages);
		Vue.component(Switch.name, Switch);
		Vue.component(TabStrip.name, TabStrip);

		Vue.component(Slide.name, Slide);
		Vue.component(Slide.name, Push);
		Vue.component("page-header", PageHeader);
		Vue.component("grid-toolbar", GridToolbar);
		Vue.component("cell-delete-command", cellDeleteCommand);
		Vue.component("cell-template", cellTemplate);
		Vue.component("headerTemplate", headerTemplateVue);

		Vue.component("default-layout", Default);
		Vue.component("no-sidebar-layout", NoSidebar);

		Vue.component("report-fitlers", ReportFilters);

		Vue.use(LayoutInstaller);
		Vue.use(DropdownsInstaller);
		Vue.use(DateinputsInstaller);
		Vue.use(ButtonsInstaller);
		Vue.use(ChartInstaller);
		Vue.use(PortalVue);
		Vue.use(DialogInstaller);

		Vue.use(PrettyCheckbox);
	}
};

export default GlobalComponents;
